import PropTypes from "prop-types";
import { svgIconsList } from "./iconsList";
import svgIconSprite from "./svgIcons.sprite.svg";

export const SvgIcons = ({
  name,
  className = "",
  width = "24",
  height = "24",
  ...props
}) => {
  return (
    <svg className={className} width={width} height={height} {...props}>
      <use href={`${svgIconSprite}#${name}`} />
    </svg>
  );
};

SvgIcons.propTypes = {
  name: PropTypes.oneOf(svgIconsList).isRequired,
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
